var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRevitIcon = function SvgRevitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b3c8f",
    fillRule: "nonzero",
    d: "M496 479.546H88.278c-13.853 0-25.081-11.23-25.081-25.083v-335.96H496z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a6afe",
    fillRule: "nonzero",
    d: "M94.276 32.454h345.501c13.853 0 25.083 11.23 25.083 25.083v335.96H94.276z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#699bea",
    fillRule: "nonzero",
    d: "m16 444.29 78.277-50.794V32.456L16 83.252v361.04z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M240.203 211.807h30.11a42.52 42.52 0 0 0 25.997-7.142 24 24 0 0 0 9.599-20.397v-14.341a23.83 23.83 0 0 0-9.599-20.34 42.5 42.5 0 0 0-25.998-7.2h-30.11v69.42zm113.357 80.675v23.484a38.45 38.45 0 0 1-15.54 2.914 37.9 37.9 0 0 1-20.34-5.314 42.45 42.45 0 0 1-14.914-17.655l-29.653-57.135h-32.91v77.19h-36.168V115.133h67.706a83.46 83.46 0 0 1 51.08 14.456 46.16 46.16 0 0 1 19.255 39.023v16.626a43.64 43.64 0 0 1-9.37 27.54 61.33 61.33 0 0 1-25.654 18.97l26.683 51.08a18.05 18.05 0 0 0 17.14 9.769z"
  })));
};
export default SvgRevitIcon;